import type { DealInsightsChartInputApi, DealInsightsCreateJobIdParamsApi } from '@openx/types/dealInsights';

export const removeUnrelatedChartsFromParamsString = (params: string, chartKey: keyof DealInsightsChartInputApi) => {
  const parsedParams = JSON.parse(params) as DealInsightsCreateJobIdParamsApi;

  const { charts, ...restParams } = parsedParams;

  return JSON.stringify({ ...restParams, charts: { [chartKey]: charts[chartKey] } });
};
